import $ from "jquery";

jQuery(document).ready(function($) {
    var $emailShareForm = $('.sharebar form');

    if( $emailShareForm.length ){
        var $messageField = $('.sharebar form textarea');
        $messageField.text(window.location.href);
    }

    $('.menu-sharebar__link.share--email').click(function(e) {
        e.preventDefault();
        var $form = $('form');

        $form.toggleClass('visible');
    });

    $('.share-by-email__form-close').click(function(e) {
        e.preventDefault();
        var $form = $('form');

        $form.toggleClass('visible');
    });

});

var shareBtn = $('.sharebar-button--share');
var menuSharebar = $('.menu-sharebar');

shareBtn.click(function() {
    menuSharebar.toggleClass("is-visible");
});